import { Accordion, AccordionDetails, AccordionSummary, AppBar, Box, Button, debounce, Dialog, Divider, Grid, List, ListItem, ListItemText, TextField, Toolbar, Typography } from "@mui/material"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { useListaDeduplicacaoService, useProjetosService } from "../../../../../../../use-cases/geo-veles"
import { theme } from "../../../../../../styles"
import { useState } from "react"
import { cpfListLenghtToLabel } from "../../../../../../../utils"
import { CreateListaDeduplicacaoForm, EditListaDeduplicacaoForm } from "./forms"
import { PreviaFiltroDeduplicacao } from "./previa-filtro-deduplicacao"
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

export const ListasDeduplicacao = (props: {
    open: boolean
}) => {
    // State
    const { openListasDeduplicacao, listasDeduplicacao, openCreateListaDeduplicacao, openEditListaDeduplicacao } = useAppSelector((state) => state.listaDeduplicacao)
    const { filtrosSelecionados } = useAppSelector((state) => state.projetos)
    // Use State
    const [searchTerm, setSearchTerm] = useState<string>('')
    // Hooks
    const {
        setOpenListasDeduplicacao,
        openCreateListaDeduplicacaoForm,
        selectListaDeduplicacaoToEdit,
        updateListaDeduplicacaoStatus
    } = useListaDeduplicacaoService()
    const { addListaDeduplicacaoFilter } = useProjetosService()
    // Functions
    const closeDialog = () => {
        setOpenListasDeduplicacao(false)
    }

    return (
        <>
            {
                props.open && <>
                    <Dialog
                        fullScreen
                        open={openListasDeduplicacao}
                        onClose={closeDialog}
                    >
                        <AppBar sx={{ position: 'relative' }}>
                            <Toolbar>
                                <Typography
                                    sx={{
                                        ml: 2,
                                        flex: 1
                                    }}
                                    textTransform="uppercase"
                                    variant="h6"
                                    component="div"
                                >
                                    Selecionar listas de deduplicação
                                </Typography>
                                <Button
                                    autoFocus
                                    color="inherit"
                                    onClick={closeDialog}
                                >
                                    Fechar
                                </Button>
                            </Toolbar>
                        </AppBar>
                        <Grid
                            container
                            spacing={1}
                            p={3}
                            display={'flex'}
                            alignItems={'center'}
                            justifyContent={'center'}
                        >
                            <Grid
                                item
                                xs={6}
                                display={'flex'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                gap={5}
                            >
                                <Button
                                    variant="outlined"
                                    startIcon={<AddIcon />}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        openCreateListaDeduplicacaoForm(true)
                                    }}
                                >
                                    Criar nova lista de deduplicação
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        for (let i = 0; i < listasDeduplicacao.length; i++) {
                                            addListaDeduplicacaoFilter(listasDeduplicacao[i].IdVelesGeoListaDeduplicacao)
                                        }
                                    }}
                                >
                                    Incluir todas as listas
                                </Button>
                            </Grid>
                            <Grid item xs={6} display={'flex'} justifyContent={'center'}>
                                <TextField
                                    fullWidth
                                    label={'Digite o nome da lista'}
                                    onChange={debounce((e) => {
                                        setSearchTerm(e.target.value)
                                    }, 500)}
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={6}>
                                <List>
                                    {
                                        listasDeduplicacao.filter((listaDeduplicacao) => {
                                            if (filtrosSelecionados) {
                                                if (filtrosSelecionados.listasDeduplicacao) {
                                                    if (filtrosSelecionados.listasDeduplicacao.includes(listaDeduplicacao.IdVelesGeoListaDeduplicacao)) {
                                                        return false
                                                    }
                                                }
                                            }

                                            if (searchTerm === '') {
                                                return true
                                            }
                                            if (listaDeduplicacao.Nome.toUpperCase().includes(searchTerm.toUpperCase())) {
                                                return true
                                            } else {
                                                return false
                                            }
                                        }).map((listaDeduplicacao) => {
                                            return (<>
                                                <ListItem
                                                    key={listaDeduplicacao.IdVelesGeoListaDeduplicacao}
                                                    secondaryAction={<>
                                                        <Button
                                                            startIcon={<EditIcon />}
                                                            onClick={(event) => {
                                                                event.stopPropagation()
                                                                selectListaDeduplicacaoToEdit(listaDeduplicacao.IdVelesGeoListaDeduplicacao)
                                                            }}
                                                        >
                                                            Editar
                                                        </Button>
                                                        <Button
                                                            startIcon={<DeleteIcon />}
                                                            onClick={(event) => {
                                                                event.stopPropagation()
                                                                updateListaDeduplicacaoStatus({
                                                                    IdVelesGeoListaDeduplicacao: listaDeduplicacao.IdVelesGeoListaDeduplicacao,
                                                                    Status: false
                                                                })
                                                            }}
                                                        >
                                                            Excluir
                                                        </Button>
                                                    </>}
                                                    button
                                                    onClick={() => {
                                                        addListaDeduplicacaoFilter(listaDeduplicacao.IdVelesGeoListaDeduplicacao)
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary={listaDeduplicacao.Nome?.toUpperCase()}
                                                        secondary={cpfListLenghtToLabel(listaDeduplicacao.CPFs?.length)}
                                                    />
                                                </ListItem>
                                                <Divider color={theme.palette.primary.main} />
                                            </>)
                                        })
                                    }
                                </List>
                            </Grid>
                            {
                                ((filtrosSelecionados?.listasDeduplicacao?.length ?? 0) > 0) &&
                                <Grid item xs={6}>
                                    <Box px={3}>
                                        <Accordion defaultExpanded>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography variant="h5" color="primary" fontWeight="bold" textTransform="uppercase">
                                                    Listas selecionadas
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <PreviaFiltroDeduplicacao />
                                            </AccordionDetails>
                                        </Accordion>
                                    </Box>
                                </Grid>
                            }
                        </Grid>
                    </Dialog>

                    <CreateListaDeduplicacaoForm openForm={openCreateListaDeduplicacao} />
                    <EditListaDeduplicacaoForm openForm={openEditListaDeduplicacao} />
                </>
            }
        </>
    )
}